/* ============================================================
   §4 Pilatix App — Tiles section JS
   1:1 port of _fitness-demo/js/main.js setupTilesVideo().

   Behaviour:
   - autoplay video when its sticky enters viewport, pause when it leaves
   - scroll-linked transform: scale(1 → 1.4) over the pin travel
   - playpause button: toggles, hides after scroll progress > 0.7
   - respects prefers-reduced-motion (no scale)

   Per-section scoping: each .pltx2-ftiles root is set up independently,
   so a page CAN have multiple §4 sections (rare, but legal).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (!root || root.__pltx2FtSetup) return;
    root.__pltx2FtSetup = true;

    var wrap    = root.querySelector('.pltx2-ftiles__videowrap');
    var sticky  = root.querySelector('[data-ftiles-sticky]');
    var video   = root.querySelector('[data-ftiles-video]');
    var playBtn = root.querySelector('[data-ftiles-playpause]');
    if (!wrap || !video) return;

    // Resolve <source> from data attr (we picked desktop/mobile in Liquid + JS)
    var desktopSrc = root.getAttribute('data-video-desktop') || '';
    var mobileSrc  = root.getAttribute('data-video-mobile')  || desktopSrc;
    var src = (window.innerWidth < 735 && mobileSrc) ? mobileSrc : desktopSrc;
    var sourceEl = video.querySelector('source');
    if (sourceEl && src) {
      // Use the file extension to set a reasonable type
      var t = 'video/mp4';
      if (/\.webm(\?|$)/i.test(src)) t = 'video/webm';
      else if (/\.mov(\?|$)/i.test(src)) t = 'video/quicktime';
      sourceEl.setAttribute('src', src);
      sourceEl.setAttribute('type', t);
      video.load();
    }

    function playVideo() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    // Play while on screen, pause when off
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) playVideo();
          else video.pause();
        });
      }, { threshold: 0.1 });
      io.observe(sticky || wrap);
    } else {
      playVideo();
    }

    // Scroll-linked scale 1 → 1.4 over the pin travel
    var MAX = reduceMotion ? 1 : 1.4;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      var stickyH = (sticky || wrap).offsetHeight;
      var span = rect.height - stickyH;
      var p = span > 0 ? (-rect.top) / span : 0;
      p = Math.min(Math.max(p, 0), 1);
      video.style.transform = 'scale(' + (1 + (MAX - 1) * p).toFixed(4) + ')';
      if (playBtn) {
        playBtn.style.opacity = Math.max(0, Math.min(1, 1 - (p - 0.7) / 0.25)).toFixed(2);
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) video.play();
        else video.pause();
      });
      video.addEventListener('play', function () {
        playBtn.classList.add('is-playing');
        playBtn.setAttribute('aria-label', playBtn.getAttribute('data-label-pause') || 'Pause video');
      });
      video.addEventListener('pause', function () {
        playBtn.classList.remove('is-playing');
        playBtn.setAttribute('aria-label', playBtn.getAttribute('data-label-play') || 'Play video');
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pltx2-ft-root]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-pltx2-ft-root]')
      : null;
    if (root) setup(root);
  });
})();
